module.exports = __webpack_public_path__ + "img/nu.7e75c525.svg";